﻿module Client.ContractPage.CostOfConstruction.Expanded.CostData

open System
open Client
open Client.ContractPage.CostOfConstruction
open Fable.React
open Fable.React.Props
open PortalLibs.Client.Util
open ContractPageModel
open Model
open Fulma
open Fable.FontAwesome
open Shared
open Feliz
open Utils

let rightMiddle = [style.textAlign.right; style.verticalAlign.middle] 

let view =
  let tdPrice x =
    Html.td [
      prop.style [yield! rightMiddle; yield! (optionalRedColor x)]
      prop.text(x |> DisplayNumber.AsCurrency.std)
    ]
  React.memo (
    "CostDataRow",
    (fun (props: {| ContractSettings: ContractSettings
                    Cost: JobCost
                    Details: CostDetails
                    Dispatch: Msg -> unit
                    Key: string |}) ->
      tr [ Style [ FontSize Config.smallTextSize ] ] [
        td [] []
        td [] [
          div [ Style [
                  Display DisplayOptions.Flex
                  PaddingLeft "3px"
                  FlexWrap "wrap"
                  VerticalAlign "middle"
                ] ] [
            span [ Style [
                     MarginRight "3px"
                     FlexGrow "1"
                     MaxWidth "75px"
                   ] ] [
              props.Cost.PhaseCode |> emptyStrTagIfNone
            ]
            span [] [
              props.Cost.Description |> emptyStrTagIfNone
            ]
          ]
        ]
        tdPrice props.Cost.EarnedRevenue
        tdPrice props.Cost.OrigEstCost
        tdPrice props.Cost.CurrentEstCost
        Html.td [
          prop.style rightMiddle
          prop.children [
            let costs = props.Cost.ActualCostToDate |> DisplayNumber.AsCurrency.std |> Html.text

            let content faIcon color =
              div [ Style [ PaddingBottom "2px" ] ] [
                costs
                Icon.icon [ Icon.Props [ Style [ Color color ] ] ] [
                  Fa.i faIcon []
                ]
              ]
            
            match props.Details with
            | NoDetails -> costs
            | Loading ->
              content [Fa.Solid.Spinner; Fa.Pulse] "gray"
            | Collapsed ->
              a [ OnClick (fun _ ->
                    props.Cost.Id
                    |> Expand
                    |> CostOfConstructionDetailsExpansion
                    |> props.Dispatch) ] [
                content [Fa.Solid.Plus] "green"
              ]
            | Expanded _ ->
              a [ OnClick (fun _ ->
                    props.Cost.Id
                    |> Collapse
                    |> CostOfConstructionDetailsExpansion
                    |> props.Dispatch) ] [
                content [Fa.Solid.Minus] "black"
              ]
          ]
        ]
        tdPrice props.Cost.CostToComplete
        tdPrice props.Cost.GrossProfit
        Html.td [
          prop.style rightMiddle
          prop.children [
            formatMargin props.Cost.GrossProfit props.Cost.EarnedRevenue
          ]
        ]

        if props.ContractSettings.Projections then
          Html.td [
            prop.style rightMiddle
            prop.text
              (sprintf "%s%%" (Math.Round(props.Cost.PctEstimate * 100.0, 1).ToString()))
          ]
          Html.td [
            prop.style [yield! rightMiddle
                        if props.Cost.PMRevisedCost < props.Cost.ActualCostToDate then
                          yield style.color.red]
            prop.text (props.Cost.PMRevisedCost |> DisplayNumber.AsCurrency.std)
          ]
      ]),
    (fun (props: {| ContractSettings: ContractSettings
                    Cost: JobCost
                    Details: CostDetails
                    Dispatch: Msg -> unit
                    Key: string |}) -> $"CostDataRow-%s{props.Key}")
  )